import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers } from 'recompose';
import { isValidated } from '@packages/helpers/core/validations/is-password-valid';
import { withDebouncedHandlers } from '../../../helpers/hocs/with-debounced-handlers';
import { resetCode, setAccountData, setAccountError } from '../../../store/reducers/account/actions';
import { addToast } from '../../../store/reducers/toast';
import { InputButtonWithIcon as ButtonWithIcon } from '../../../components/buttons/button-with-icon';
import { InputField as Input } from '../../../components/inputs/input';
import { AccountPage } from '../../../templates/account';
import { Validators, withCompletedPrevStep } from '../components';

const Component = ({ value, error, validators, isValid, handleChange, handleSubmit }) => {
  const {
    ACCOUNT: {
      RESET_PASSWORD: {
        title,
        identifier,
        subheading,
        pageHeader,
        password: {
          label,
          inPageMessage,
          message,
          heading,
          body,
          legalFooter,
          buttons: { confirm }
        }
      }
    }
  } = window.CONFIG;

  return (
    <AccountPage
      title={title}
      subheading={subheading}
      category={identifier}
      inPageMessage={inPageMessage}
      message={message}
      heading={heading}
      body={body}
      legalFooter={legalFooter}
      onSubmit={isValid && handleSubmit}
      pageHeader={pageHeader}
    >
      <Input
        data-atid='reset-password-password-input'
        type='password'
        label={label}
        value={value}
        onChange={handleChange}
        error={error}
      />
      <Validators items={validators} />
      <ButtonWithIcon data-atid='reset-password-submit-button' buttonType='submit' disabled={!isValid}>
        {confirm}
      </ButtonWithIcon>
    </AccountPage>
  );
};

const mapStateToProps = ({ account }) => {
  const value = account.password;

  return {
    value,
    error: account.resettingCodeError,
    ...isValidated(value)
  };
};

export const ResetPasswordPassword = compose(
  withCompletedPrevStep('/account/reset-password'),
  connect(mapStateToProps, { setAccountData, setAccountError, resetCode }),
  withHandlers({
    handleChange:
      ({ setAccountData }) =>
      value =>
        setAccountData('password', value)
  }),
  withDebouncedHandlers({
    handleSubmit:
      ({ history, resetCode }) =>
      () => {
        const {
          DISPLAY_COMPONENTS: { TOAST },
          TOAST: {
            messages: { account }
          }
        } = window.CONFIG;

        resetCode(() => {
          history.push({
            pathname: '/account/reset-password/magic-code',
            state: { completed: true }
          });

          TOAST.ACCOUNT && addToast({ message: account.text, to: account.to });
        });
      }
  }),
  lifecycle({
    componentDidMount() {
      const { setAccountData, setAccountError } = this.props;

      setAccountData('password', '');
      setAccountError('resettingCodeError', '');
    }
  })
)(Component);
